import { CoreStringValueBuilderPart } from "./CoreModels"


export interface CoreGoogleClassroomConfiguration {
    id: string
    includeClasses: boolean
    includeCourses: boolean
    studentMemberMode: GoogleClassroomMemberMode
    teacherMemberMode: GoogleClassroomMemberMode
    classroomClassesNaming: CoreStringValueBuilderPart[]
    classroomCoursesNaming: CoreStringValueBuilderPart[]
    classroomNaming: GoogleClassroomNaming
    archiveGracePeriod: number | null
    deleteGracePeriod: number | null
    aliasTrackingModuleType: string | null
    serviceAccounts: CoreGoogleClassroomServiceAccount[]
    activityInformationMarkingFilters?: string[]
}

export enum GoogleClassroomMemberMode {
    Strict = 0,
    Permissive = 1
}

export enum GoogleClassroomNaming {
    Unspecified = 0,
    ActivityName = 1,
    ActivitySchoolName = 2,
    ActivitySchoolShortNameWithFallbackToSchoolName = 3
}

export interface CoreGoogleClassroomServiceAccount {
    id?: string
    emailAddress?: string
    googleId?: string
    classroomOwnerCount: number
}
